import { motion } from "motion/react";
import className from "classnames/bind";
import { forwardRef, useMemo } from "react";
import { TypePill } from "@components";
import ArrowRight from "@/assets/svg/arrow-tail-right-no-padding.svg";
import { usePageWrapperData } from "@/providers/PageWrapperContext";

import styles from "./RockHallResults.module.scss";
const cx = className.bind(styles);

const formatPrice = (product: ShopifyCarouselProduct): string => {
  const min = parseFloat(product.priceRange.minVariantPrice.amount);
  const max = parseFloat(product.priceRange.maxVariantPrice.amount);
  const currency = product.priceRange.minVariantPrice.currencyCode || "USD";
  const fmt = (n: number) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(n);
  if (min === max) return fmt(min);
  return `${fmt(min)} – ${fmt(max)}`;
};

const ShopResult = forwardRef<HTMLDivElement, ShopifyCarouselProduct>(
  (product, ref) => {
    const { title, onlineStoreUrl, featuredImage } = product;
    const price = useMemo(() => formatPrice(product), [product]);
    const { labels: { postTypeLabels: { shop } = { } } = {} } = usePageWrapperData();
    const shopLabel = shop || "Shop";

    if (!onlineStoreUrl) return null;

    return (
      <div ref={ref}>
        <a
          className={cx("rockhall-result", "rockhall-result--shop")}
          href={onlineStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={cx("rockhall-result__image")}>
            {featuredImage?.url && (
              <img src={featuredImage.url} alt={title} loading="lazy" />
            )}
          </div>
          <div className={cx("rockhall-result__content")}>
            <TypePill type="shop" copy={shopLabel} />
            <h3 className={cx("title-lc-xs")}>{title}</h3>
            <p className={cx("shop-price")}>{price}</p>
            <ArrowRight className={cx("rockhall-result__arrow")} />
          </div>
        </a>
      </div>
    );
  }
);

export default motion.create(ShopResult);
